import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Send, Save, Loader2 } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
const auth = () => {
  const t = localStorage.getItem('authToken');
  return { withCredentials: true, headers: t ? { Authorization: `Bearer ${t}` } : {} };
};
const errMsg = (e) => e.response?.data?.detail || 'הפעולה נכשלה';

export const AccountantSend = ({ year, defaultMonth }) => {
  const [email, setEmail] = useState('');
  const [month, setMonth] = useState(defaultMonth);
  const [sending, setSending] = useState(false);

  useEffect(() => { axios.get(`${API}/settings/accountant`, auth()).then((r) => setEmail(r.data.email || '')).catch(() => {}); }, []);
  useEffect(() => setMonth(defaultMonth), [defaultMonth]);

  const save = async () => {
    try {
      await axios.put(`${API}/settings/accountant`, { email }, auth());
      toast({ title: 'כתובת רואה החשבון נשמרה' });
    } catch (e) { toast({ title: 'שגיאה', description: errMsg(e), variant: 'destructive' }); }
  };

  const send = async () => {
    setSending(true);
    try {
      await axios.put(`${API}/settings/accountant`, { email }, auth());
      const r = await axios.post(`${API}/reports/vat-monthly/send-accountant`, { year, month }, auth());
      toast({ title: 'נשלח לרואה החשבון', description: `${r.data.email} · ${r.data.invoices} חשבוניות רכש מצורפות${r.data.missing.length ? ` · חסרים קבצים: ${r.data.missing.join(', ')}` : ''}` });
    } catch (e) { toast({ title: 'שגיאה', description: errMsg(e), variant: 'destructive' }); }
    setSending(false);
  };

  return (
    <Card className="shadow-lg print:hidden" data-testid="accountant-send-card">
      <CardHeader><CardTitle className="flex items-center gap-2"><Send className="w-5 h-5 text-indigo-600" />שליחה לרואה החשבון</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-gray-500">נשלח במייל: קובץ אקסל של דוח המע"מ + כל קבצי חשבוניות הרכש של החודש הנבחר.</p>
        <div className="flex flex-wrap gap-2 items-center">
          <Input type="email" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="accountant@example.com" className="max-w-xs" data-testid="accountant-email-input" />
          <Button variant="outline" onClick={save} className="border-2" data-testid="accountant-email-save-btn"><Save className="w-4 h-4 ml-1" />שמור</Button>
          <select value={month} onChange={(e) => setMonth(+e.target.value)} className="p-2 border-2 rounded-md" data-testid="accountant-month-select">
            {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m} {year}</option>)}
          </select>
          <Button onClick={send} disabled={sending || !email} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="accountant-send-btn">
            {sending ? <Loader2 className="w-4 h-4 ml-1 animate-spin" /> : <Send className="w-4 h-4 ml-1" />}שלח לרואה החשבון
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
